module.exports = __webpack_public_path__ + "b3218d8ce4727fe575d56fef0e67fc74.pdf";